export default {
  store_layout: {
    headline: 'هنا يمكنك تعديل تخطيط رأس وتذييل متجرك',
    filter: {
      fields: {
        search: {
          placeholder: 'البحث بالإسم'
        }
      }
    },
    form: {
      title: {
        create: 'إنشاء هيكل المتجر',
        edit: 'تعديل هيكل المتجر'
      },
      fields: {
        name: {
          title: 'اسم',
          placeholder: 'اكتب اسما'
        },
        layout_i18ns: {
          tabs: {
            en: {
              title: 'الإنجليزية'
            },
            ar: {
              title: 'العربية'
            },
            fr: {
              title: 'الفرنسية'
            },
            es: {
              title: 'الإسبانية'
            },
            it: {
              title: 'الإيطالية'
            }
          }
        }
      },
      buttons: {
        create: 'أنشئ هيكل',
        save: 'حفظ الهيكل',
        cancel: 'إلغاء',
        duplicate: 'نسخ',
        preview: 'معاينة',
        edit: 'تعديل',
        delete: 'حذف'
      }
    }
  },
  store_page: {
    store_page_i18n: {
      dialogs: {
        delete: {
          title: 'حذف صفحة المتجر',
          content: 'هل أنت متأكد أنك تريد حذف صفحة المتجر هذه؟'
        }
      },
      buttons: {
        preview: 'معاينة',
        edit: 'تعديل',
        delete: 'حدف'
      },
      form: {
        fields: {
          content: {
            tab_name: 'محتوى'
          },
          page_i18ns: {
            tabs: {
              en: {
                title: 'الإنجليزية'
              },
              ar: {
                title: 'العربية'
              },
              fr: {
                title: 'الفرنسية'
              },
              es: {
                title: 'الإسبانية'
              },
              it: {
                title: 'الإيطالية'
              }
            }
          },
          meta_data: {
            tab_name: 'العنوان والوصف',
            title: {
              title: 'العنوان',
              placeholder: 'اكتب عنوان الصفحة التعريفية'
            },
            description: {
              title: 'الوصف',
              placeholder: 'اكتب وصف الصفحة'
            }
          },
          tracking_data: {
            tab_name: 'البكسلات'
          }
        }
      }
    }
  },
  store_settings: {
    dialogs: {
      update_status: {
        title: 'تحديث حالة المتجر',
        content: 'هل أنت متأكد أنك تريد تحديث حالة هذا المتجر؟'
      }
    },
    form: {
      edit: 'تعديل المتجر',
      create: 'إنشاء متجر',
      buttons: {
        create: 'إنشاء متجر',
        save: 'حفظ المتجر',
        cancel: 'إلغاء'
      },
      fields: {
        create: {
          alert: {
            info: {
              title: 'ملحوظة:',
              content: 'يمكنك إرفاق اسم المجال الخاص بك بمتجرك لاحقًا.'
            }
          },
          store_name: {
            title: 'اسم المتجر',
            placeholder: 'أدخل اسم المتجر',
            hint: 'يجب أن يحتوي اسم المتجر على أحرف إنجليزية وأرقام و- فقط.'
          },
          language: {
            title: 'اللغة'
          }
        },
        edit: {
          tabs: {
            general: {
              title: 'عام',
              fields: {
                language_type: {
                  title: 'نوع اللغة',
                  plan_warning: '<span style="font-weight: bold">ترقية الإشتراك</span> مطلوب لتفعيل هذا الخيار!'
                },
                default_language: {
                  title: 'اللغة الافتراضية',
                  options: {
                    english: 'الإنجليزية',
                    arabic: 'العربية',
                    french: 'الفرنسية',
                    spanish: 'الإسبانية',
                    italian: 'الإيطالية'
                  }
                }
              }
            },
            domain: {
              title: 'دومين',
              fields: {
                substitution_domain: {
                  title: 'الدومين البديل'
                },
                domain: {
                  title: 'الدومين الرئيسي',
                  placeholder: 'إختر دومين'
                }
              }
            },
            style: {
              title: 'المظهر',
              fields: {
                layout: {
                  title: 'هيكل المتجر'
                }
              }
            },
            checkout_form: {
              title: 'إستمارة الطلب',
              fields: {
                general: {
                  title: 'عام'
                },
                checkout_form: {
                  title: 'إستمارة الطلب'
                },
                shipping: {
                  title: 'التوصيل'
                },
                reviews: {
                  title: 'الاراء'
                }
              }
            },
            addons: {
              title: 'الإضافات'
            },
            pixels: {
              title: 'النيكسلات'
            },
            payment: {
              title: 'الدفع المياشر'
            }
          }
        }
      }
    },
    filter: {
      search: {
        placeholder: 'التصفية حسب المجال/المجال الفرعي'
      },
      search_by_user: {
        placeholder: 'التصفية حسب المستخدم'
      },
      domain: {
        placeholder: 'حدد المجال'
      }
    }
  }
};